/**
 * This file contains types that aim to make it easier to work with visx types.
 */
import {AxisScaleOutput} from '@visx/axis';
import {PickD3Scale} from '@visx/scale';

export interface Margin {
  top: number;
  left: number;
  bottom: number;
  right: number;
}

export enum TextAnchor {
  END = 'end',
  MIDDLE = 'middle',
  START = 'start',
}

/**
 * Scale types are typed as string literals in visx. This enum makes it easy to use the scale types with visx
 * types by defining an enum for the string literals. The values are lowercase since those correspond to the
 * string literal types in visx.
 */
export enum VisxScaleType {
  BAND = 'band',
  LINEAR = 'linear',
  LOG = 'log',
  POINT = 'point',
  UTC = 'utc',
}

export type VisxAxisScale<ScaleType extends VisxScaleType = VisxScaleType> = PickD3Scale<
  ScaleType,
  AxisScaleOutput
>;
